import { useTranslation } from '@mukil/i18n';
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from '@jumpstone/ui-react';
import { useNotifications } from '../../data/use_dashboard';
import { format_relative_time } from '../../lib/format';
import { BellIcon } from './bell_icons';

const NOTIFICATION_KEY = {
  expenses_awaiting_approval: 'notification.expenses_awaiting_approval',
  filing_due: 'notification.filing_due',
  bank_update_requested: 'notification.bank_update_requested',
} as const;

/** Nav bell: unread count plus the notification list. */
export function NavBell({
  pending_count,
}: {
  pending_count: number;
}): React.JSX.Element {
  const { t, locale } = useTranslation('wp');
  const { notifications, now } = useNotifications();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="relative"
          aria-label={t('notification.open', { count: pending_count })}
        >
          <BellIcon size={17} />
          {/* Badge intentionally omitted: no cheap cross-screen count endpoint exists yet — restore when one lands (issue #24350 follow-up). */}
        </Button>
      </DropdownMenuTrigger>
      {/* max-w caps the panel to the viewport (minus a small margin) on
          phones narrower than 300px + collision padding, so it can't get
          clipped off the right edge. */}
      <DropdownMenuContent
        align="end"
        className="w-[300px] max-w-[calc(100vw-2rem)]"
      >
        <DropdownMenuLabel>{t('notification.heading')}</DropdownMenuLabel>
        {notifications.map((notification) => (
          <div
            key={notification.id}
            className="px-2.5 py-2 text-[13px] border-b border-[color:var(--line)] last:border-b-0"
          >
            <div className="font-semibold">
              {t(NOTIFICATION_KEY[notification.kind], {
                count: notification.count ?? 0,
                days: notification.days ?? 0,
                name: notification.actor ?? '',
              })}
            </div>
            <div className="text-[12px] text-[color:var(--ink-muted)] mt-0.5">
              {format_relative_time(notification.at, now, locale)}
            </div>
          </div>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
